import {
  LayoutDashboard,
  ShoppingCart,
  ClipboardList,
  ChefHat,
  History,
  UtensilsCrossed,
  Tags,
  Users,
  Wallet,
  Receipt,
  BarChart3,
  Settings,
  ShieldCheck,
  ScrollText,
  type LucideIcon,
} from 'lucide-react';
import { PERMISSIONS } from './permissions';

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Required permission(s). Any one grants visibility. Omit = any signed-in user. */
  anyOf?: string[];
  /** Grouping for the sidebar. */
  section: 'Operations' | 'Catalog' | 'Business';
}

export const NAV_ITEMS: NavItem[] = [
  {
    label: 'Dashboard',
    to: '/dashboard',
    icon: LayoutDashboard,
    section: 'Operations',
    anyOf: [PERMISSIONS.DASHBOARD_VIEW, PERMISSIONS.DASHBOARD_VIEW_LIMITED],
  },
  {
    label: 'New Order',
    to: '/pos',
    icon: ShoppingCart,
    section: 'Operations',
    anyOf: [PERMISSIONS.ORDERS_CREATE],
  },
  {
    label: 'Active Orders',
    to: '/orders/active',
    icon: ClipboardList,
    section: 'Operations',
    anyOf: [PERMISSIONS.ORDERS_VIEW],
  },
  {
    label: 'Kitchen',
    to: '/kitchen',
    icon: ChefHat,
    section: 'Operations',
    anyOf: [PERMISSIONS.KITCHEN_VIEW],
  },
  {
    label: 'Order History',
    to: '/orders/history',
    icon: History,
    section: 'Operations',
    anyOf: [PERMISSIONS.ORDERS_VIEW],
  },
  {
    label: 'Payments',
    to: '/payments',
    icon: Wallet,
    section: 'Operations',
    anyOf: [PERMISSIONS.PAYMENTS_COLLECT],
  },
  {
    label: 'Products',
    to: '/products',
    icon: UtensilsCrossed,
    section: 'Catalog',
    anyOf: [PERMISSIONS.PRODUCTS_MANAGE],
  },
  {
    label: 'Categories',
    to: '/categories',
    icon: Tags,
    section: 'Catalog',
    anyOf: [PERMISSIONS.CATEGORIES_MANAGE],
  },
  {
    label: 'Customers',
    to: '/customers',
    icon: Users,
    section: 'Catalog',
    anyOf: [PERMISSIONS.CUSTOMERS_MANAGE],
  },
  {
    label: 'Expenses',
    to: '/expenses',
    icon: Receipt,
    section: 'Business',
    anyOf: [PERMISSIONS.EXPENSES_MANAGE],
  },
  {
    label: 'Reports',
    to: '/reports',
    icon: BarChart3,
    section: 'Business',
    anyOf: [PERMISSIONS.REPORTS_VIEW],
  },
  {
    label: 'Users',
    to: '/users',
    icon: ShieldCheck,
    section: 'Business',
    anyOf: [PERMISSIONS.USERS_MANAGE],
  },
  {
    label: 'Audit Log',
    to: '/audit',
    icon: ScrollText,
    section: 'Business',
    anyOf: [PERMISSIONS.AUDIT_VIEW],
  },
  {
    label: 'Settings',
    to: '/settings',
    icon: Settings,
    section: 'Business',
    anyOf: [PERMISSIONS.SETTINGS_MANAGE],
  },
];

export const NAV_SECTIONS: NavItem['section'][] = ['Operations', 'Catalog', 'Business'];
